import { fromJS } from 'immutable';
// @ts-expect-error untyped dependency
import { getDefaultOptions } from '../../../highcharts/options/defaultOptions';
// @ts-expect-error untyped dependency
import { getLegendPositionOptions } from '../../../highcharts/options/legendOptions';
import { getVennTooltipFormatter } from './tooltips/vennTooltip';
import { renderToString } from 'react-dom/server';
import { createElement } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { ColorSwatch } from 'foundations-components/transitional/components/ColorSwatch';
export const buildVennChartOptions = (vennOptions, reportingThemes) => {
  var _vennOptions$style, _vennOptions$style2;
  const {
    legend: legendOptions = {},
    chart: legendOffsets = {}
  } = getLegendPositionOptions((_vennOptions$style = vennOptions.style) === null || _vennOptions$style === void 0 ? void 0 : _vennOptions$style.legendPosition, (_vennOptions$style2 = vennOptions.style) === null || _vennOptions$style2 === void 0 ? void 0 : _vennOptions$style2.legendWidth);
  const chartOptions = fromJS({
    chart: Object.assign({
      type: 'venn'
    }, legendOffsets),
    series: [{
      type: 'venn',
      data: vennOptions.data,
      dataLabels: vennOptions.dataLabels,
      showInLegend: true,
      legendType: 'point'
    }],
    plotOptions: {
      venn: {
        clip: false,
        states: {
          hover: {
            enabled: true
          },
          inactive: {
            enabled: true
          }
        },
        point: {
          events: {
            legendItemClick() {
              return false;
            }
          }
        }
      }
    },
    legend: Object.assign({
      enabled: true
    }, legendOptions, {
      useHTML: true,
      squareSymbol: false,
      symbolWidth: 0,
      labelFormatter() {
        var _this$sets;
        if (((_this$sets = this.sets) === null || _this$sets === void 0 ? void 0 : _this$sets.length) === 1) {
          return renderToString( /*#__PURE__*/createElement(Flex, {
            alignItems: 'center'
          }, /*#__PURE__*/createElement(Flex, {
            alignItems: 'center'
          }, /*#__PURE__*/createElement(ColorSwatch, {
            color: this.color,
            size: 4
          }), /*#__PURE__*/createElement('span', {
            style: {
              marginLeft: '4px'
            }
          }, this.name))));
        }
        return null;
      }
    }),
    tooltip: {
      enabled: !vennOptions.tooltipDisabled,
      formatter: getVennTooltipFormatter()
    }
  });
  return getDefaultOptions({
    reportingThemes
  }).mergeDeep(chartOptions);
};